/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class hubBlog extends HTMLElement {
  constructor() {
    super();
    this.nbResults = this.querySelector('.pagination-result-count .nb_items_visible');
    this.articlesPerLoad = parseInt(this.getAttribute('data-per-page'));
    this.currentlyVisible = this.articlesPerLoad;
  }
  connectedCallback() {
    this.loadMoreBtn = this.querySelector('#load-more-button');
    if (!this.loadMoreBtn) return;
    this.loadMoreBtn.addEventListener('click', () => this.loadMore());
  }
  disconnectedCallback() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.removeEventListener('click', () => this.loadMore());
    }
  }
  loadMore() {
    this.hiddenArticles = this.querySelectorAll('.blog-articles__article.hidden');
    this.articlesToShow = Array.from(this.hiddenArticles).slice(0, this.articlesPerLoad);
    this.articlesToShow.forEach(article => {
      article.classList.remove('hidden');
    });
    this.currentlyVisible += this.articlesToShow.length;
    this.nbResults.textContent = this.currentlyVisible;
    if (this.hiddenArticles.length <= this.articlesPerLoad) {
      this.loadMoreBtn.parentElement.classList.add('hidden');
    }
  }
}
customElements.define('hub-blog', hubBlog);
/******/ })()
;